<script>import * as d3 from "d3";
import { okhsl } from "../../d3-mapp/color/index.js";
import { onMount } from "svelte";
import {
  getElementFont,
  getTextMetrics
} from "../util/text-size.js";
import Swatch from "../../components/legend/Swatch.svelte";
export let position = "left";
export let tag = "";
export let scale;
export let ticks = void 0;
export let label;
export let labelSwatch = void 0;
export let ether;
export let thresholds = void 0;
let axisContainerNode;
let axisNode;
let axisLabel;
let labelFontProps;
let labelWidth;
let labelX;
let labelY;
let labelRect = void 0;
let labelFontSize;
let mounted = false;
onMount(() => {
  mounted = true;
});
$: {
  if (mounted) {
    let axisGenerator = position === "left" ? d3.axisLeft(scale) : d3.axisRight(scale);
    if (ticks !== void 0) {
      axisGenerator.ticks(ticks);
    }
    d3.select(axisNode).call(axisGenerator);
    if (axisLabel) {
      labelFontProps = labelFontProps ?? getElementFont(axisLabel);
      labelWidth = labelWidth ?? parseFloat(labelFontProps.lineHeight);
      labelFontSize = parseFloat(labelFontProps.size);
      const tickSize = axisGenerator.tickSize();
      const tickValues = axisGenerator.tickValues() ?? scale.ticks();
      const tickFormatter = axisGenerator.tickFormat() ?? scale.tickFormat();
      const tickLabels = tickValues.map((v, i) => tickFormatter(v, i));
      const tickLabelLengths = tickLabels.map(
        (label2) => getTextMetrics(label2, labelFontProps.font).width
      );
      const ticksLabelSize = tickLabelLengths.reduce(
        (max, size) => Math.max(max, size),
        0
      );
      labelX = (position === "left" ? -1 : 1) * (tickSize + ticksLabelSize + labelWidth);
      const labelRotation = position === "left" ? -90 : 90;
      labelY = scale.range()[1] + (scale.range()[0] - scale.range()[1]) / 2;
      d3.select(axisLabel).attr("x", labelX).attr("y", labelY).attr("transform", `rotate(${labelRotation}, ${labelX}, ${labelY})`);
      labelRect = axisLabel.getBBox();
    }
    updateEtherLines(ether);
  }
}
const updateEtherLines = (ether2) => {
  const useEtherLines = ether2 !== void 0 && (position === "left" ? ether2 > 0 : ether2 < 0);
  const useThresholdLines = thresholds && thresholds.length > 0 && ether2 !== void 0 && ether2 !== 0;
  axisNode.querySelectorAll(".tick").forEach(
    (tick) => {
      const tickValue = parseFloat(tick.children[1].textContent);
      const isVisible = ether2 !== void 0 && ether2 !== 0 && (!thresholds || thresholds.length === 0 || thresholds.findIndex(
        (threshold) => threshold.value === tickValue
      ) === -1);
      if (tick.lastElementChild?.tagName.toLowerCase() === "line") {
        if (useEtherLines && isVisible) {
          tick.lastElementChild.setAttribute(
            "x2",
            ether2.toString()
          );
        } else {
          tick.removeChild(tick.lastElementChild);
        }
      } else {
        if (useEtherLines && isVisible) {
          const lineNode = document.createElementNS("http://www.w3.org/2000/svg", "line");
          lineNode.classList.add("ether");
          lineNode.setAttribute("stroke", "currentColor");
          lineNode.setAttribute("x2", ether2.toString());
          tick.appendChild(lineNode);
        } else {
        }
      }
    }
  );
};
$: {
  if (mounted) {
    updateEtherLines(ether);
  }
}
</script>

<g class="axis scalar-axis {tag}" bind:this={axisContainerNode}>
  <g bind:this={axisNode} class="sub-axis" />
  {#if thresholds && thresholds.length > 0 && ether !== undefined && ether !== 0}
    <g class="thresholds">
      {#each thresholds as threshold, i}
        {#if scale(threshold.value) >= scale.range()[1] && scale(threshold.value) <= scale.range()[0]}
          <line
            class="threshold"
            stroke={threshold.stroke[0].color.formatHex()}
            width="1"
            x2={(position === "left" ? 1 : -1) * Math.abs(ether)}
            y1={scale(threshold.value)}
            y2={scale(threshold.value)}
          />
        {/if}
      {/each}
    </g>
  {/if}
  !-- {#if labelSwatch && labelRect !== undefined}
    <Swatch
      out="svg"
      color={labelSwatch}
      type={"circle"}
      x={labelX - 0.8*labelFontSize}
      y={labelY + labelRect.width/2 + 0.8*labelFontSize  }
      size={labelFontSize}
    />
  {/if}

  {#if label && label.length > 0}
    <text
      bind:this={axisLabel}
      class="axis-label"
      text-anchor="middle"
      fill="currentColor"
    >
      {label}
    </text>
  {/if}
</g>
